import React, { useEffect, useState } from "react";
import { Card, Typography, Button, Table, Space, Input } from "antd";
import httpInjectorService from "services/http-injector.service";
import { toast } from "react-toastify";
import { Radio, RadioGroup, Stack, Select } from "@chakra-ui/react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Text,
} from "@chakra-ui/react";
import httpGetService from "services/http-Get.service";

const { Title } = Typography;

const ListWorkItems = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editedRow, setEditedRow] = useState({});

  const [showdeletemodal, setShowdeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const [option, setOption] = useState("");
  const [selectedLinkType, setSelectedLinkType] = useState("");
  const [linkitemcount, setlinkedItemCount] = useState(0);

  const isEditing = (record) => record.id === editingId;

  const filteredLinkTypes = data.filter((item) => item.id !== selectedId);

  const handleEdit = (record) => {
    setEditingId(record.id);
    setEditedRow({ ...record });
  };

  const handleDeletemodal = (id) => {
    setSelectedId(id);
    fetchLinkedItemsCount(id);
    setShowdeleteModal(true);
    

    // reset modal state
    setOption("");
    setSelectedLinkType("");
     

    
  };

  const handleClosemodal = () => {
    setShowdeleteModal(false);
    setlinkedItemCount(0);
  };

  const fetchLinkedItemsCount = async (id) => {
  
    try {
      let response = await httpInjectorService.fetchLinkedWorkItemsCount(id);
      if (response.status === "success") {
       setlinkedItemCount(response.data[0].count);
       
      } else {
        setlinkedItemCount(0);
      }
    } catch (error) {
      console.error(error);
      setlinkedItemCount(0);
    }
  };

  const handleChange = (e, field) => {
    setEditedRow({
      ...editedRow,
      [field]: e.target.value,
    });
  };

  const handleSave = async () => {
    try {
      setLoading(true);

      const reqBody = {
        link_type_id: editedRow.id,
        name: editedRow.link_type_name,
        outward: editedRow.outward_label,
        inward: editedRow.inward_label,
      };

      let response = await httpInjectorService.editLinkType(reqBody);

      if (response.status === "success") {
        toast.success("Updated successfully");
        setEditingId(null);
        fetchWorkItems();
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmDelete = async () => {
  try {
    setLoading(true);

    let query = `?old_linkType_id=${selectedId}`;
    if (linkitemcount > 0) {
      if (option === "move") {
        if (!selectedLinkType) {
          toast.error("Please select a link type");
          return;
        }
        query += `&new_linkType_id=${selectedLinkType}`;
      }
      
    }

    let response = await httpInjectorService.deleteLinkType(query);

    if (response.status === "success") {
      toast.success(response.message);
      fetchWorkItems();
    } else {
      toast.error(response.message);
    }

    handleClosemodal();
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

  const columns = [
    {
      title: "Name",
      dataIndex: "link_type_name",
      render: (text, record) =>
        isEditing(record) ? (
          <Input
            value={editedRow.link_type_name}
            onChange={(e) => handleChange(e, "link_type_name")}
          />
        ) : (
          text
        ),
    },
    {
      title: "Outward Description",
      dataIndex: "outward_label",
      render: (text, record) =>
        isEditing(record) ? (
          <Input
            value={editedRow.outward_label}
            onChange={(e) => handleChange(e, "outward_label")}
          />
        ) : (
          text
        ),
    },
    {
      title: "Inward Description",
      dataIndex: "inward_label",
      render: (text, record) =>
        isEditing(record) ? (
          <Input
            value={editedRow.inward_label}
            onChange={(e) => handleChange(e, "inward_label")}
          />
        ) : (
          text
        ),
    },
    {
      title: "Actions",
      render: (_, record) => {
        const editable = isEditing(record);

        return editable ? (
          <Space>
            <Button type="link" onClick={handleSave}>
              Save
            </Button>
            <Button type="link" onClick={() => setEditingId(null)}>
              Cancel
            </Button>
          </Space>
        ) : (
          <Space>
            <Button type="link" onClick={() => handleEdit(record)}>
              Edit
            </Button>

            <Button
              type="link"
              danger
              onClick={() => handleDeletemodal(record.id)}
            >
              Delete
            </Button>
          </Space>
        );
      },
    },
  ];

  const fetchWorkItems = async () => {
    try {
      setLoading(true);
      const res = await httpInjectorService.listLinkTypes();
      setData(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWorkItems();
    
  }, []);
  

  return (
    <Card
      style={{
        position: "fixed",
        top: "170px",
        left: "50px",
        right: "0px",
        bottom: 0,
        overflow: "auto",
      }}
    >
      <Title level={3}>Work items</Title>

      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        rowKey="id"
        pagination={false}
      />

      {/* ✅ MODAL */}
      <Modal isOpen={showdeletemodal} onClose={handleClosemodal}>
        <ModalOverlay />

        <ModalContent mt="200px">
          <ModalHeader>Confirm Delete</ModalHeader>

          <ModalBody>
            {linkitemcount === 0 ? (
              // ✅ NO LINKED ITEMS
              <Text fontWeight="bold">
                Are you sure you want to delete this?
              </Text>
            ) : (
              // ✅ LINKED ITEMS EXIST
              <>
                <Text mb={3} fontWeight="bold" color="red.500">
                  {linkitemcount} linked work item(s) found
                </Text>

                <Text mb={3}>
                  Please select how you want to handle linked work items:
                </Text>

                <RadioGroup value={option} onChange={setOption}>
                  <Stack direction="column" spacing={3}>
                    <Radio value="move">
                      Move linked work items to another link type
                    </Radio>

                    {option === "move" && (
                      <Select
                        placeholder="Select link type"
                        mt={2}
                        value={selectedLinkType}
                        onChange={(e) =>
                          setSelectedLinkType(e.target.value)
                        }
                      >
                        {filteredLinkTypes.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.link_type_name}
                          </option>
                        ))}
                      </Select>
                    )}

                    <Radio value="delete">
                      Remove and delete all linked work items
                    </Radio>
                  </Stack>
                </RadioGroup>
              </>
            )}
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="red"
              size="sm"
              mr={3}
              onClick={handleConfirmDelete}
              isDisabled={
                linkitemcount > 0 &&
                option === "move" &&
                !selectedLinkType
              }
            >
              Confirm
            </Button>

            <Button variant="ghost" onClick={handleClosemodal}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Card>
  );
};

export default ListWorkItems;